// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 3524 ? "app" : chunkId) + "." + {"3524":"7c0cb5be960d80a5d979","4120":"10ce2bdb4c854c95a31d"}[chunkId] + ".css";
};